<template>
  <section class="section">
    <div class="container-lg partners--section">
      <div class="section__header  text-center">
        <h2 class="section__title">
          {{ in18['page_manufacturers'] }}
        </h2>
      </div>
      <ul class="partners">
        <li v-for="manufacture in manufacturers" class="partners__item">
          <a :href="manufacture.link" :title="manufacture.title">
            <picture>
              <source :srcset="manufacture.image.webp" media="(max-width: 767px)" type="image/webp">
              <img :alt="manufacture.title" data-sizes="auto" width="50" height="50" :src="manufacture.image.source" class="partners__logo lazyload">
            </picture>
          </a>
        </li>
      </ul>
      <div class="text-center  mt-5">
        <a :href="manufacturers_link" :title="in18['page_see_all']" class="btn  btn--red">
          {{ in18['page_see_all'] }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name:  "Manufacturers",
  props: [
    'in18',
    'manufacturers',
    'manufacturers_link',
  ],
}
</script>